import { z } from 'zod'

export const playbookSearchSchema = z.object({
	q: z.string().optional(),
	action: z.string().optional(),
	settings: z.string().optional(),
})
